import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

const Rosters = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminRosters()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.roster,
      list: REDUCER_KEY.rosters
    }}
    config={config}
    permissions={permissions}
  />
);

Rosters.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default Rosters;
